<template>
  <div class="form-section">
    <!-- row markup -->
    <div
      v-if="isRowMarkup"
      class="row"
    >
      <div
        v-if="labelVisible"
        class="col-md-3"
      >
        <label
          :for="name"
          class="form__label"
        >
          {{ label }}
        </label>
      </div>
      <div :class="columnWidth">
        <div class="form-section__column">
          <slot />
          <div
            v-show="hasError"
            class="form-section__error"
          >
            {{ error }}
          </div>
          <div
            v-if="hasHint"
            class="form-section__hint"
            v-html="hint"
          />
        </div>
      </div>
    </div>

    <!-- column markup -->
    <div
      v-if="isColumnMarkup"
      :class="columnMarkupClasses"
      class="column"
    >
      <div class="column__container">
        <label
          v-if="labelVisible"
          :for="name"
          class="form__label"
        >
          {{ label }}
        </label>
        <div class="form-section__column">
          <slot />
        </div>
      </div>
      <div
        v-show="hasError"
        class="form-section__error"
      >
        {{ error }}
      </div>
      <div
        v-if="hasHint"
        class="form-section__hint"
        v-html="hint"
      />
    </div>
  </div>
</template>

<script>
import isBlank from 'is-blank'

export default {
  name: 'FormSection',
  props: {
    direction: {
      type: String,
      default: () => 'horizontal',
      validator: value => ['horizontal', 'vertical', 'flex'].includes(value)
    },
    name: {
      type: String,
      required: true
    },
    error: {
      type: String,
      default: () => null
    },
    label: {
      type: String,
      default: () => null
    },
    labelVisible: {
      type: Boolean,
      default: () => true
    },
    fullWidth: {
      type: Boolean,
      default: () => false
    },
    hint: {
      type: String,
      default: () => null
    }
  },
  computed: {
    hasError () {
      return !isBlank(this.error)
    },
    hasHint () {
      return !isBlank(this.hint)
    },
    isRowMarkup () {
      return ['horizontal'].includes(this.direction)
    },
    isColumnMarkup () {
      return ['vertical', 'flex'].includes(this.direction)
    },
    isFlexLayout () {
      return ['flex'].includes(this.direction)
    },
    columnMarkupClasses () {
      return {
        'column--flex': this.isFlexLayout
      }
    },
    columnWidth () {
      return this.fullWidth
        ? 'col-md-12'
        : 'col-md-9'
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.form-section
  position: relative

  & + &
    margin-top: rem-calc($grid-gutter-width-half)

.form-section .row
  +respond-min($md)
    display: flex
    align-items: flex-start

.form__label
  +ellipsis
  +font-size(15, 25)
  color: $color-form-label-1
  display: block
  font-weight: 600
  margin-top: rem-calc(19)
  margin-bottom: rem-calc(10)

  +respond-min($md)
    text-align: right

.form-section[required]
  .form__label:after
    content: '*'

.column
  .form__label
    +respond-min($md)
    text-align: left

.form-section__column
  position: relative

.form-section__error
  color: #d00
  font-size: rem-calc(12)
  font-weight: 600
  margin-top: rem-calc(8)

.form-section__hint
  +font-size(14, 20)
  margin-top: rem-calc(6)
  color: #666

.column--flex
  .column__container
    display: flex

  .form__label
    margin-right: auto
</style>



// WEBPACK FOOTER //
// src/components/forms/FormSection.vue